var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSgyMw(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2751_26845)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.48 3.51C15.8 -1.17 8.19 -1.17 3.51 3.51C-1.17 8.19 -1.17 15.8 3.51 20.48C5.85 22.82 8.92 23.99 12 23.99C15.08 23.99 18.15 22.82 20.49 20.48C25.17 15.8 25.17 8.19 20.49 3.51H20.48ZM18.32 4.25L11.99 10.58L5.67 4.25C7.5 2.75 9.75 2 12 2C14.25 2 16.49 2.75 18.33 4.25H18.32ZM19.06 19.06C15.16 22.96 8.82 22.96 4.92 19.06C1.26 15.4 1.04 9.58 4.25 5.66L11.99 13.4L19.73 5.66C22.94 9.58 22.72 15.4 19.06 19.06Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2751_26845"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSgyMw);
export default __webpack_public_path__ + "static/media/SGY-MW.2623958fbee1a7f2191a7c959db344a1.svg";
export { ForwardRef as ReactComponent };